import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { chatReducer } from './chatSlice';
import { rootDataReducer } from './rootDataSlice';
import { uiReducer } from './uiSlice';
export const store = configureStore({
    reducer: combineReducers({
        chat: chatReducer,
        rootData: rootDataReducer,
        ui: uiReducer
    }),
    devTools: process.env.NODE_ENV !== 'production',
});
